export class RevisionPeriodo{
	constructor(
		public estado_revision: string,
		public fecha_vencimiento: string,
		public fecha: string,
		public hora: string,
		public observaciones: string

	){}
}